import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    line-height: 1.6;
    color: ${props => props.theme.colors.darkGray};
    background-color: ${props => props.theme.colors.lightGray};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  main {
    flex: 1;
    padding: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: ${props => props.theme.spacing.sm};
  }

  h1 {
    font-size: 2.5rem;
    color: ${props => props.theme.colors.darkBlue};
  }

  h2 {
    font-size: 2rem;
    color: ${props => props.theme.colors.darkBlue};
  }

  h3 {
    font-size: 1.5rem;
    color: ${props => props.theme.colors.blue};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.sm};
  }

  a {
    color: ${props => props.theme.colors.blue};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${props => props.theme.colors.darkBlue};
    }
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    border-radius: ${props => props.theme.borderRadius.md};
    transition: all 0.3s ease;
    font-weight: 500;

    &:focus {
      outline: 2px solid ${props => props.theme.colors.blue};
      outline-offset: 2px;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  input, select, textarea {
    font-family: inherit;
    border: 2px solid ${props => props.theme.colors.gray};
    border-radius: ${props => props.theme.borderRadius.md};
    padding: ${props => props.theme.spacing.sm};
    transition: border-color 0.3s ease;

    &:focus {
      outline: none;
      border-color: ${props => props.theme.colors.blue};
    }

    &:invalid {
      border-color: ${props => props.theme.colors.red};
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.md};
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  /* WCAG 2.0 Compliance */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  /* High contrast mode support */
  @media (prefers-contrast: high) {
    button, input, select, textarea {
      border-width: 3px;
    }
  }

  /* Focus indicators for keyboard navigation */
  .focus-visible {
    outline: 3px solid ${props => props.theme.colors.blue};
    outline-offset: 2px;
  }

  /* Skip links for screen readers */
  .skip-link {
    position: absolute;
    top: -40px;
    left: 6px;
    background: ${props => props.theme.colors.blue};
    color: ${props => props.theme.colors.white};
    padding: 8px;
    text-decoration: none;
    border-radius: 4px;
    z-index: 1000;
    
    &:focus {
      top: 6px;
    }
  }

  /* Ensure sufficient color contrast */
  .high-contrast {
    filter: contrast(1.5);
  }

  /* Large text for better readability */
  .large-text {
    font-size: 1.2em;
    line-height: 1.6;
  }

  /* Ensure interactive elements are keyboard accessible */
  button, input, select, textarea, [role="button"], [tabindex] {
    &:focus {
      outline: 2px solid ${props => props.theme.colors.blue};
      outline-offset: 2px;
    }
  }

  /* Screen reader only content */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;
